export enum SuccessStep {
	forgotPasswordEmailSent = 'Forgot password email sent',
	passwordChanged = 'Password changed',
	registrationComplete = 'Registration complete',
	verifyEmail = 'Verify email',
	verifyEmailResend = 'Verify email resend', //should no longer be used
	pwlessLoginEmailSent = 'Passwordless login email sent',
	resendPwlessLoginEmail = 'Passwordless login email resend',
}
